import React, { useEffect, useRef, useState } from "react";
import { BsTwitter } from "react-icons/bs";
import CostumeCanvas from "../../components/CostumeCanvas";
import CostumeUI from "../../components/CostumeUI";
import useQuery from "../../hooks/useQuery";
import {
  CostumeSet,
  costumeRegistry,
  defaultCostumeSet,
} from "../../lib/costumes/Costume";
import CostumeCompositor from "../../lib/costumes/CostumeCompositor";
import {
  decodeCostumes,
  encodeCostumes,
} from "../../lib/costumes/CostumePresentation";
import { costumeTextureRegistry } from "../../lib/costumes/CostumeTexture";
import "./CosutumesPage.scoped.scss";

interface Props {
  name: string;
}

export default function CosutumePage(props: Props) {
  const query = useRef(useQuery());
  const [costumes, setCostumes] = useState<CostumeSet>(defaultCostumeSet);
  const cosutmeCompositor = useRef<CostumeCompositor>(
    new CostumeCompositor(costumeRegistry, costumeTextureRegistry)
  );

  useEffect(() => {
    const queryParam = query.current.get("p");

    if (queryParam) {
      setCostumes(decodeCostumes(costumeRegistry, queryParam));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!cosutmeCompositor.current.validateCostumeSet(costumes)) {
      setCostumes(defaultCostumeSet);
      return;
    }
  }, [costumes]);

  const getTweetLink = () => {
    const urlParams = new URLSearchParams({
      p: encodeCostumes(costumes),
    });
    const url = `https://akikunsuki.com/birthday2021/costumes?${urlParams.toString()}`;
    const text = `似合ってるかな？\nNew #きせかえアキくん 2021\n${url}`;
    const params = new URLSearchParams({ text: text });
    return "https://twitter.com/intent/tweet?" + params.toString();
  };

  return (
    <div className="costume-container">
      <div className="costume-canvas">
        <CostumeCanvas
          costumes={costumes}
          costumeCompositor={cosutmeCompositor.current}
        />
      </div>
      <div className="costume-menu">
        <CostumeUI costumes={costumes} setCostumes={setCostumes} />
        <div className="px-1 costume-tweet">
          <button className="w-full h-8 text-white bg-blue-400 rounded hover:bg-blue-500">
            <a
              className="inline-block w-full p-1"
              target="_blank"
              rel="noreferrer"
              href={getTweetLink()}
            >
              <BsTwitter /> きせかえをツイート
            </a>
          </button>
        </div>
      </div>
    </div>
  );
}
